import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import Reporting from '@/components/reporting/Reporting/Reporting';
import { setCountryBaseCurrency } from '@/components/reporting/store/actions/baseCurrency.actions';
import { setBaseCurrencyCatalog, setUserRoles } from '@/components/reporting/store/actions/resources.actions';
import { setCurrentUser } from '@/components/reporting/store/actions/user.actions';
import reportingStore from '@/components/reporting/store/reportingStore';
import { useGlobalStore } from '@/store/global';
import { getBaseCurrency } from '@/store/global/baseCurrency/selectors';
import { getUser } from '@/store/global/user/selectors';
import { getUserRoles } from '@/store/global/userRoles/selectors';

export default function ReportingPage() {
  const [searchParams] = useSearchParams();
  const campaignIds = (searchParams.get('cids') ?? '').split(',').filter(Boolean);

  const user = useGlobalStore(getUser);
  const userRoles = useGlobalStore(getUserRoles);
  const baseCurrency = useGlobalStore(getBaseCurrency);

  useEffect(() => {
    if (user) {
      reportingStore.dispatch(setCurrentUser(user.toJSON()));
    }
  }, [user]);

  useEffect(() => {
    if (userRoles?.length) {
      reportingStore.dispatch(setUserRoles(userRoles));
    }
  }, [userRoles]);

  useEffect(() => {
    if (baseCurrency?.baseCurrency) {
      reportingStore.dispatch(setCountryBaseCurrency(baseCurrency));
      reportingStore.dispatch(setBaseCurrencyCatalog([baseCurrency]));
    }
  }, [baseCurrency]);

  if (!user || !userRoles.length || !baseCurrency) {
    return null;
  }

  return (
    <Reporting
      campaignIds={campaignIds}
      initialCurrency={baseCurrency.baseCurrency}
      user={user.toJSON()}
      userRoles={userRoles}
    />
  );
}
